export function getQuantity(summaryFileExtensions, formatTitle) {
  return summaryFileExtensions[formatTitle.toLowerCase()]
}
